import { ForkJobPurpose } from '@gtpl/shared-models/warehouse-management';
import { Injectable } from '@nestjs/common';
import { ForkLiftItemsDto } from '../../fork-lift-items/dto/fork-lift-items.dto';
import { ForkLiftItems } from '../../fork-lift-items/fork-lift-items.entity';
import { ForkLiftJobs } from '../fork-lift-jobs.entity';
import { ForkLiftJobStatus } from './fork-lift-job-status.enum';
import { ForkLiftJobDto } from './fork-lift-job.dto';
import { ForkLiftResponseDto } from './fork-lift-response.dto';

@Injectable()
export class ForkLiftJobAdapter {
  
  public convertDtoToEntity(  forkLiftJobDTO: ForkLiftJobDto,  isUpdate: boolean = false, count:number ): ForkLiftJobs {
    console.log(forkLiftJobDTO);
    const forkLiftJobs = new ForkLiftJobs();
    forkLiftJobs.transactionType=forkLiftJobDTO.transactionType;
    forkLiftJobs.status=forkLiftJobDTO.status;
    forkLiftJobs.transactionTime=forkLiftJobDTO.transactionTime;
    forkLiftJobs.message=forkLiftJobDTO.message;
    forkLiftJobs.reportedId=forkLiftJobDTO.reportedId;
    forkLiftJobs.plantId=forkLiftJobDTO.plantId;
    forkLiftJobs.totalIssuedQuantity=forkLiftJobDTO.totalIssuedQuantity;
    forkLiftJobs.jobCode = "JOB/" + count;
    forkLiftJobs.createdUser = forkLiftJobDTO.createdUser;
    forkLiftJobs.transferStatus = forkLiftJobDTO.transferStatus;
    forkLiftJobs.fromPlantId = forkLiftJobDTO.fromPlantId;
    forkLiftJobs.toPlantId = forkLiftJobDTO.toPlantId;
    if(forkLiftJobDTO.totalJobCartons){
      forkLiftJobs.totalJobCartons = forkLiftJobDTO.totalJobCartons;
    }

    // if(!forkLiftJobDTO.jobId){
    //     forkLiftJobs.jobCode = "JOB/" + count;
    //     forkLiftJobs.createdUser = forkLiftJobDTO.createdUser;
    // }else{
    //     forkLiftJobs.updatedUser = forkLiftJobDTO.updatedUser;
    //     forkLiftJobs.jobId = forkLiftJobDTO.jobId;
    // }
    const jobItems: ForkLiftItems[]  = []; 
    for (const forkLiftItems of forkLiftJobDTO.forkLiftItemsInfo) {
      console.log("forkLiftItemsforkLiftItems"+ forkLiftItems.jobCartons);
      console.log("forkLiftItemsforkLiftItems"+ forkLiftItems.issuedQuantity);
        const itemsEntity: ForkLiftItems = new ForkLiftItems();
        // if(!forkLiftItems.forkLiftItemId){
        //     forkLiftJobs.createdUser = forkLiftJobs.createdUser;
        // }else{
        //     itemsEntity.forkLiftItemId = forkLiftItems.forkLiftItemId;
        //     forkLiftJobs.updatedUser = forkLiftJobs.updatedUser; 
        // }
        itemsEntity.saleOrderId = forkLiftItems.saleOrderId;
        itemsEntity.saleOrderItemId = forkLiftItems.saleOrderItemId;
        itemsEntity.pallet = forkLiftItems.pallet;
        itemsEntity.currentPosition = forkLiftItems.currentPosition;
        itemsEntity.targetPosition = forkLiftItems.targetPosition;
        itemsEntity.realPosition = forkLiftItems.realPosition;
        itemsEntity.issuedQuantity = forkLiftItems.issuedQuantity;
        itemsEntity.date = forkLiftJobDTO.transactionTime;
        itemsEntity.stockId = forkLiftItems.stockId;
        itemsEntity.unitId = forkLiftItems.unitId;

        if(forkLiftItems.jobCartons){
          itemsEntity.jobCartons = forkLiftItems.jobCartons;
        }
        jobItems.push(itemsEntity);
    }
    forkLiftJobs.forkLiftItemsInfo = jobItems;
    return forkLiftJobs;
  }
  public convertEntityToDto(forkLiftJobObject: ForkLiftJobs): ForkLiftResponseDto {
    const forkLiftJobDTO= new ForkLiftResponseDto;
    forkLiftJobDTO.jobId = forkLiftJobObject.jobId;
    forkLiftJobDTO.jobCode = forkLiftJobObject.jobCode;
    forkLiftJobDTO.transactionType = forkLiftJobObject.transactionType;
    forkLiftJobDTO.plantId = forkLiftJobObject.plantId;
    forkLiftJobDTO.message = forkLiftJobObject.message;
    forkLiftJobDTO.reportedId = forkLiftJobObject.reportedId;
    forkLiftJobDTO.status = forkLiftJobObject.status;
    forkLiftJobDTO.transactionTime = forkLiftJobObject.transactionTime;
    forkLiftJobDTO.createdUser = forkLiftJobObject.createdUser;
    forkLiftJobDTO.updatedUser = forkLiftJobObject.updatedUser;
    forkLiftJobDTO.forkLiftItemsInfo = forkLiftJobObject.forkLiftItemsInfo;
    return forkLiftJobDTO;
  }
}
